module.exports = __webpack_public_path__ + "static/img/close_icon.c3077f2b.png";